import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/constants/landingAssets";

export default function HowItWorksSection({ t }) {
  return (
    <section id="demo" className="py-16" data-testid="demo-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold text-[#CDA34F] uppercase tracking-[0.2em] mb-3 bg-[#CDA34F]/10 px-4 py-1.5 rounded-full">{t.demo.suptitle}</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.demo.title}</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">{t.demo.subtitle}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {t.demo.steps.map((step, i) => (
            <div key={i} className="relative" data-testid={`demo-step-${i}`}>
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center h-full">
                <div className="w-10 h-10 rounded-full bg-[#CC0000] text-white font-black text-lg flex items-center justify-center mx-auto mb-4">{step.num}</div>
                <div className="w-12 h-12 rounded-xl bg-[#CDA34F]/10 flex items-center justify-center mx-auto mb-4"><step.icon className="w-6 h-6 text-[#CDA34F]" /></div>
                <h3 className="font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
              {i < 3 && <div className="hidden lg:block absolute top-1/2 -right-3 w-6 text-gray-300"><ArrowRight className="w-6 h-6" /></div>}
            </div>
          ))}
        </div>
        <div className="flex justify-center">
          <img src={IMAGES.workflow} alt="Workflow" className="max-w-3xl w-full rounded-2xl shadow-lg border border-gray-200" />
        </div>
      </div>
    </section>
  );
}
